import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,
  state: {
    files: [],
    links: null,
    meta: null,
    filter: {
      keyword: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.files = [];
    },
    SET_FILES(state, data) {
      state.files = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setFiles({ commit }, data) {
      commit('SET_FILES', data);
    },

    getDirs() {
      return http('/directories')
        .then((response) => response.body);
    },

    createDirs(_, data) {
      return http('/directories', { method: 'POST', data })
        .then((response) => response.body);
    },

    getFileByDir(_, dir) {
      return http(`/files?dir=${dir}`)
        .then((response) => response.body);
    },

    find({ commit, state }, dir) {
      let url = `/files?is_page=1&dir=${dir}&${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('News'));
          return response.body;
        })
        .then((response) => {
          commit('SET_FILES', response);
        });
    },

    save(_, {
      id, ...data
    }) {
      return http(`/files/${id}`, { method: 'PUT', data })
        .then((response) => response.body);
    },

    destroy(_, id) {
      return http(`/files/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

  },
};
